export default "__VITE_ASSET__455d0c18__"